import { PaymentStatusFilterType } from '../pages/PaymentsDashboard';
import { AnalyticsFiltersKeys } from '../pages/AnalyticsDashboard';
import { OrderStatusFilterType } from '../pages/HEDashboard';
import { ItemId } from '../pages/profile/GenieConfiguration';
import { FilterType } from '../pages/profile/ListGenieItems';
import { HEOnboardingState } from '../pages/heOnboarding/HEOnboarding';
import { TrialOrderState, TrialOrderType } from '../pages/trialOrder/TrialOrderHomePage';
import { KhataStatusFilterType } from '../pages/MyKhata';
import { isAllClinics } from '../store/localstorage';

export const APP_PREFIX = '/app';
export const OUT_PAGES = `${APP_PREFIX}/out`;

export const GO_TO_PRINT_PDF = (fileName: string): string => `${OUT_PAGES}/print/${fileName}`;

export const GO_TO_BORROW_PRESCRIPTION_WITH_ID = (plId: string, id: string): string =>
    `${APP_PREFIX}/utils/prescription/borrow/${plId}/${id}`;
export const GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID = (pxId: string): string =>
    `${APP_PREFIX}/utils/prescription/fetch-upsert/${pxId}`;
export const GO_TO_VISIT_CALL_WITH_ID = (vId: string): string => `${APP_PREFIX}/visit/call/${vId}`;

export const GO_TO_PATIENTS_DETAILS = (
    plId: string,
    subRoute: PT_DETAILS_SUB_ROUTES,
    subRouteParam?: string,
): string => `${APP_PREFIX}/patient/${plId}/${subRoute}${subRouteParam ? `/${subRouteParam}` : ''}`;

export const GO_TO_LOGIN = `${APP_PREFIX}/login`;

export const GO_TO_UHI_LOGIN = `${OUT_PAGES}/uhi`;
export const REGISTER_ABDM = `${OUT_PAGES}/register-abdm`;

export const DOC_ASSIST_AI = (docId: string, ptId?: string): string =>
    `${OUT_PAGES}/doc-assist-ai/${docId}${ptId ? `/${ptId}` : ''}`;

export const GO_TO_ANALYTICS_DASHBOARD = (
    analyticsFilter?: AnalyticsFiltersKeys,
    startDate?: string,
    endDate?: string,
): string => {
    if ((!startDate && !endDate) || !analyticsFilter) {
        return `${APP_PREFIX}/analytics`;
    }

    return `${APP_PREFIX}/analytics?${AnalyticsDashboardQueryParams.analytics_filter}=${analyticsFilter}&${AnalyticsDashboardQueryParams.start_date}=${startDate}&${AnalyticsDashboardQueryParams.end_date}=${endDate}`;
};

export type PROFILE_TABS_TYPE =
    | 'invite'
    | 'sync'
    | 'downloadPtDatabase'
    | 'uhidConfig'
    | 'qr'
    | 'profile'
    | 'messageConfiguration'
    | 'manageTreatmentPackages'
    | 'staffRestriction'
    | 'activate-payments'
    | 'genie-configuration'
    | 'edit-template'
    | 'receipt-config'
    | 'buy-premium'
    | 'book-training-premium'
    | 'manage-services'
    | 'manage-treatment-packages'
    | 'appointment-configs'
    | 'abha-qr';

type SettingsSubRoute = ':subRoute' | PROFILE_TABS_TYPE;

export type ProfileRouterParams = { subRoute: SettingsSubRoute };

export const GO_TO_SETTINGS = (
    subRoute: SettingsSubRoute,
    itemId?: ItemId,
    filterType?: FilterType,
): string =>
    `${APP_PREFIX}/settings/${subRoute}${itemId && filterType ? `/${itemId}/${filterType}` : ''}`;

export const GO_TO_MY_PROFILE = `${APP_PREFIX}/myprofile`;
export const GO_TO_MY_RX_TEMPLATE = `${APP_PREFIX}/rx-template`;
export const GO_TO_BOOK_TRAINING = `${APP_PREFIX}/request-training`;
export const GO_TO_SUBSCRIBE = `${APP_PREFIX}/subscribe-to-premium`;
export const GO_TO_ADD_EKA_CREDITS = `${APP_PREFIX}/add-eka-credits`;

export const GO_TO_MY_GENIE = (
    subRoute: SettingsSubRoute,
    itemId?: ItemId,
    filterType?: FilterType,
): string =>
    `${APP_PREFIX}/genie/${subRoute}${itemId && filterType ? `/${itemId}/${filterType}` : ''}`;

export const GO_TO_PATIENT_REFERRAL = `${APP_PREFIX}/patient-referral`;
export const GO_TO_MY_CALENDAR = `${APP_PREFIX}/calendar`;
export const GO_TO_SCHEDULE = (cId?: string): string => `${APP_PREFIX}/beta/schedule/${cId}`;
export const GO_TO_PAYMENTS_DASHBOARD = (
    paymentStatusFilter: PaymentStatusFilterType | ':paymentStatusFilter',
    clinic_id: string,
    startDate?: string,
    endDate?: string,
): string => {
    if (!startDate && !endDate) {
        return `${APP_PREFIX}/payments/${paymentStatusFilter}/${clinic_id}`;
    }
    return `${APP_PREFIX}/payments/${paymentStatusFilter}/${clinic_id}?${PaymentsDashboardQueryParams.start_date}=${startDate}&${PaymentsDashboardQueryParams.end_date}=${endDate}`;
};

export const GO_TO_RECEIPT_CONFIG = ({ clinic_id }: { clinic_id: string }): string =>
    `${APP_PREFIX}/receipt-config/${clinic_id}`;

export const GO_TO_HE_DASHBOARD = (
    orderStatusFilterType: OrderStatusFilterType | ':orderStatusFilter',
    startDate?: string,
    endDate?: string,
    showDashboard?: boolean,
): string => {
    if (!startDate && !endDate) {
        return `${APP_PREFIX}/he/${orderStatusFilterType}?${
            showDashboard ? 'showDashboard=true' : ''
        }`;
    }
    return `${APP_PREFIX}/he/${orderStatusFilterType}?${
        PaymentsDashboardQueryParams.start_date
    }=${startDate}&${PaymentsDashboardQueryParams.end_date}=${endDate}${
        showDashboard ? '&showDashboard=true' : ''
    }`;
};
export const GO_TO_MY_KHATA = (
    orderStatusFilterType: KhataStatusFilterType | ':khataStatusFilter',
    startDate?: string,
    endDate?: string,
): string => {
    if (!startDate && !endDate) {
        return `${APP_PREFIX}/my-khata/${orderStatusFilterType}`;
    }
    return `${APP_PREFIX}/my-khata/${orderStatusFilterType}?${PaymentsDashboardQueryParams.start_date}=${startDate}&${PaymentsDashboardQueryParams.end_date}=${endDate}`;
};
export const GO_TO_ABHA_DASHBOARD = `${APP_PREFIX}/abha-dashboard`;
export const GO_TO_NEW_HXNG_FLOW = `${APP_PREFIX}/new-hxng-flow`;
export const GO_TO_EKA_SCRIBESDK_DEMO = `${APP_PREFIX}/sdk-eka-scribe`;
export const GO_TO_SETUP_APP = `${APP_PREFIX}/setup`;
export const GO_TO_LOGOUT = `${APP_PREFIX}/logout`;
export const GO_TO_FLUSH = `${OUT_PAGES}/flush`;
export const GO_TO_REDIRECT_IPAD = `${APP_PREFIX}/redirect-ipad`;
export const GO_TO_ADD_NEW_PATIENT = (cId: string): string => `${APP_PREFIX}/patients/new/${cId}`;

export const GET_USER_AGENT = `${APP_PREFIX}/ghost/user-agent`;

export const GO_TO_ALL_PATIENTS = (cId: string): string => `${APP_PREFIX}/patients/clinic/${cId}`;

export type APP_VALID_SECTIONS = 'today-queue' | 'completed' | 'upcoming' | 'others' | 'follow-ups';
export type APP_SECTIONS = ':section?' | '' | APP_VALID_SECTIONS;

export const GO_TO_APPOINTMENTS = (
    cId: string,
    section: APP_SECTIONS = 'today-queue',
    force?: boolean,
    query_params?: string,
): string => {
    const isNewView = (window.localStorage.getItem('isNewView') || 'true') as string;
    if (isNewView === 'true') {
        return GO_TO_NEW_APPOINTMENT(cId, query_params);
    } else {
        return GO_TO_OLD_APPOINTMENTS(cId, section, force);
    }
};

export const GO_TO_OLD_APPOINTMENTS = (
    cId: string,
    section: APP_SECTIONS = 'today-queue',
    force?: boolean,
    query_params?: string,
): string =>
    `${APP_PREFIX}/appointments/clinic/${cId}/${section}${
        force
            ? `?force=true${query_params ? `&${query_params}` : ''}`
            : `${query_params ? `?${query_params}` : ''}`
    }`;

export const GO_TO_NEW_APPOINTMENT = (cId: string, query_params?: string): string => {
    let clinicId = cId;
    if (cId !== ':cId' && isAllClinics()) {
        clinicId = 'all';
    }
    return `${APP_PREFIX}/appointments/clinic/${clinicId}/queue/${
        query_params ? `?${query_params}` : ''
    }`;
};

export const INIT_VISIT_WITH_FROM_ID = `${APP_PREFIX}/init/visit`;
export const INIT_VISIT_FROM_APP_ID = (appId: string): string =>
    `${INIT_VISIT_WITH_FROM_ID}?vid=${appId}`;

export const GO_TO_CHANGE_DOC = `${APP_PREFIX}/change-doc`;
export const GO_TO_CHANGE_GROUP = `${APP_PREFIX}/change-group`;
export const INIT = `${APP_PREFIX}/init`;

export type PX_STATE = 'edit' | 'preview' | 'finish' | ':pxState';
export type PP_SUB_ROUTES =
    | 'visit'
    | 'medical-history'
    | ':subRoute?'
    | 'medical-records'
    | 'past-vitals'
    | 'past-sa'
    | 'assessment-summary'
    | 'patient-overview'
    | 'related-profiles'
    | 'vaccination'
    | 'milestones'
    | 'treatment-plan'
    | 'care-canvas'
    | 'medical-records';
export type PT_DETAILS_SUB_ROUTES =
    | 'visit'
    | 'medical-history'
    | ':subRoute'
    | 'medical-records'
    | 'past-vitals'
    | 'past-sa'
    | 'orders'
    | 'receipts'
    | 'medical-certificates'
    | 'patient-overview'
    | 'treatments'
    | 'dental-treatments'
    | 'abha-requests';

export const GO_TO_PRESCRIPTION_PAD = (
    pxId: string,
    pxState: PX_STATE,
    subRoute?: PP_SUB_ROUTES,
    subRouteParam?: string,
): string => {
    return GO_TO_PRESCRIPTION_PAD_V2(pxId, pxState, subRoute, subRouteParam);
};

export const GO_TO_PRESCRIPTION_PAD_V2 = (
    pxId: string,
    pxState: PX_STATE,
    subRoute?: PP_SUB_ROUTES,
    subRouteParam?: string,
): string => {
    return `${APP_PREFIX}/prescription-v2/${pxId}/${pxState}${subRoute ? `/${subRoute}` : ''}${
        subRoute && subRouteParam ? `/${subRouteParam}` : ''
    }`;
};

export enum PaymentsDashboardQueryParams {
    time_filter = 'time-filter',
    start_date = 'start_from',
    end_date = 'to',
}
export enum AnalyticsDashboardQueryParams {
    start_date = 'start_from',
    end_date = 'to',
    analytics_filter = 'analytics',
}

export interface BorrowPrescriptionRouterProps {
    plId: string;
    pxId: string;
}

/**
 * @deprecated
 */
export interface PrescriptionPadRouterProps {
    pxId: string;
    cId?: string;
}

export interface PPRouterProps {
    pxId: string;
    pxState: PX_STATE;
    subRoute?: PP_SUB_ROUTES;
    subRouteParam?: string;
}

export interface PtDetailsProps {
    plId: string;
    subRoute: PT_DETAILS_SUB_ROUTES;
    subRouteParam?: string;
}

export interface PrescriptionRouterProps {
    pxId: string;
}

export type RouteParams = PrescriptionPadRouterProps;

export const PAYMENT_DASHBOARD_ROUTE = GO_TO_PAYMENTS_DASHBOARD(':paymentStatusFilter', ':cId');
export const RECEIPT_CONFIG_ROUTE = GO_TO_RECEIPT_CONFIG({ clinic_id: ':cId' });
export const HE_DASHBOARD_ROUTE = GO_TO_HE_DASHBOARD(':orderStatusFilter');
export const MY_KHATA_ROUTE = GO_TO_MY_KHATA(':khataStatusFilter');
export const ALL_PATIENTS_ROUTE = GO_TO_ALL_PATIENTS(':cId?');

export const PRESCRIPTION_PAD_V2_ROUTE = GO_TO_PRESCRIPTION_PAD_V2(
    ':pxId',
    ':pxState',
    ':subRoute?',
    ':subRouteParam?',
);

export const GO_TO_HE_ONBOARDING = (state: HEOnboardingState | ':state'): string =>
    `${APP_PREFIX}/hxng/onboarding/${state}`;

export const GO_TO_HE_TRIAL_ORDER = (
    type: TrialOrderType | ':type',
    state: TrialOrderState | ':state',
): string => `${APP_PREFIX}/hxng/trial-order/${type}/${state}`;

export const MR_PDF = `${OUT_PAGES}/mr-pdf`;

export const IPD_LIST = `${APP_PREFIX}/ipd-list`;
